import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export default class LoadingIndicatorService {
  loaderState = new Subject<boolean>();

  show() {
    this.loaderState.next(true);
  }

  hide() {
    this.loaderState.next(false);
  }
}
